import { axiosConsignadoInstance } from "./axiosInstance";
import { ConsignadoProduct } from "@/models/consignado-product.model";

export const getProductById = async (id: string): Promise<ConsignadoProduct> => {
  try {
    const response = await axiosConsignadoInstance.get<ConsignadoProduct>(`/api-consignado-trabalhador/v1/produtos/${id}`);
    return response.data;
  } catch (error) {
    console.error("Erro ao obter Produto:", error);
    throw error;
  }
};

export const getAllProducts = async (): Promise<ConsignadoProduct[]> => {
  try {
    const response = await axiosConsignadoInstance.get<ConsignadoProduct[]>(`/api-consignado-trabalhador/v1/produtos`);

    return response.data;
  } catch (error) {
    console.error('Error fetching products:', error);
    throw error;
  }
};


export const getProductsByCorbanId = async (
  corbanId: string
): Promise<ConsignadoProduct[]> => {
  try {
    const response = await axiosConsignadoInstance.get<ConsignadoProduct[]>(
      `/api/product/corban/${corbanId}`
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao obter produtos por Corban ID:", error);
    throw error;
  }
};

export const createProduct = async (
  productData: Partial<ConsignadoProduct>
): Promise<ConsignadoProduct> => {
  try {
    const response = await axiosConsignadoInstance.post<ConsignadoProduct>(
      `/api-consignado-trabalhador/v1/produtos`,
      productData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao criar produto:", error);
    throw error;
  }
};

export const updateProduct = async (
  id: string,
  productData: Partial<ConsignadoProduct>
): Promise<ConsignadoProduct> => {
  try {
    const response = await axiosConsignadoInstance.put<ConsignadoProduct>(
      `/api-consignado-trabalhador/v1/produtos/${id}`,
      productData
    );
    return response.data;
  } catch (error) {
    console.error("Erro ao atualizar produto:", error);
    throw error;
  }
};

// export const deleteProduct = async (id: string): Promise<void> => {
//   try {
//     await axiosConsignadoInstance.delete(`/api/product/${id}`);
//   } catch (error) {
//     console.error("Erro ao deletar produto:", error);
//     throw error;
//   }
// };
